<template>
  <v-card class="mb-8">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.commons.filters.title") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-show="view.elem.datatable.visible" class="py-0">
      <v-layout row wrap>
        <v-flex md12>
          <filters ref="filters" @filter="filter" />
        </v-flex>
        <v-flex md12>
          <v-data-table
            ref="dataTable"
            v-model="seleccionados"
            item-key="RowNum"
            class="geoloc dataTable"
            sort-by="clave"
            :sort-desc="true"
            :headers="view.elem.datatable.headers"
            :items="view.elem.datatable.data"
            :loading="view.elem.datatable.loading"
            :footer-props="view.elem.datatable.footerprops"
            :must-sort="true"
            :server-items-length="view.elem.datatable.total"
            :options.sync="options"
            item-value="RowNum">
            <template #top>
              <v-text-field v-model.trim="search" dense hide-details :label="$t('view.commons.search')" append-icon="mdi-magnify" />
            </template>
            <template #item.fecha="{ item }">
              <span>{{ item.fecha.replace("T", " ") }}</span>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>
<script>
import GeolocalizacionAPI from "@/services/bitacoras/geolocalizacion";
import Filters from "@/views/bitacoras/geolocalizacion/Filters"; /** *******************************/
import transform from "@/helpers/server-side-datatable";
import { formatDateTime } from "@/helpers/date-methods";

export default {
  components: { Filters }
  , data() {
    return {
      options: {}
      , filtros: {}
      , loading: []
      , search: ""
      , seleccionados: []
      , view: {
        action: { submit: { busy: false } }
        , elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.commons.clave"), align: "center", sortable: true, class: "tablaHeader", value: "clave" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.fecha.th"), align: "center", sortable: true, class: "tablaHeader", value: "fecha" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.proceso.th"), align: "left", sortable: true, class: "tablaHeader", value: "proceso" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.servicio.th"), align: "left", sortable: true, class: "tablaHeader", value: "servicio" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.direccion.th"), align: "left", sortable: true, class: "tablaHeader", value: "direccion" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.vendor.th"), align: "left", sortable: true, class: "tablaHeader", value: "vendor" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.se.th"), align: "center", sortable: true, class: "tablaHeader", value: "se" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.base.th"), align: "center", sortable: true, class: "tablaHeader", value: "base" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.baseDetalle.th"), align: "center", sortable: true, class: "tablaHeader", value: "baseDetalle" }
              , { text: this.$t("view.bitacoras.geolocalizacion.tabla.username.th"), align: "left", sortable: true, class: "tablaHeader", value: "username" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , methods: {
    prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;

      this.view.elem.datatable.loading = true;
      this.$refs.filters.loading(true);

      const serverSideDataT = this.prepareData();
      const response = await GeolocalizacionAPI.list(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
      this.$refs.filters.loading(false);
    }
    , async filter(filters) {
      let fls = { ...filters };
      Object.keys(fls).forEach(function (key) {
        if (fls[key].length > 0) {
          if (Array.isArray(fls[key])) {
            fls[key] = fls[key].join();
          }
        } else {
          delete fls[key];
        }
      });
      this.filtros = fls;
      this.options.page = 1;
      this.load();
    }
    , refreshData() {
      this.load();
    }
    , formatDateTime
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bitacoras/geolocalizacion/DataTable.vue